/** Единственный модуль форматирования. Числа нигде больше не собираются вручную. */

const THIN = ' '

/** Разряды тонким пробелом, как в макете: 25 763 334. */
export function grp(s: string | number): string {
  return String(s).replace(/\B(?=(\d{3})+(?!\d))/g, THIN)
}

/** $14 203 / −$1.47. От $1000 — без копеек. */
export function usd(v: number, dp?: number): string {
  const n = Math.abs(v)
  const d = dp != null ? dp : n >= 1000 ? 0 : 2
  const parts = n.toFixed(d).split('.')
  parts[0] = grp(parts[0])
  return (v < 0 ? '−$' : '$') + parts.join('.')
}

export function signedUsd(v: number, dp?: number): string {
  return (v >= 0 ? '+' : '') + usd(v, dp)
}

export function bps(v: number, dp = 2): string {
  return (v >= 0 ? '+' : '−') + Math.abs(v).toFixed(dp) + ' bps'
}

export function pct(v: number, dp = 2): string {
  return v.toFixed(dp) + '%'
}

/**
 * Восьмизначная цена читается только если хвост приглушён:
 * `1.0008` + `39895`. Возвращает [значащая часть, хвост].
 */
export function splitPx(v: number): [string, string] {
  let s: string
  let cut: number
  if (v >= 100) {
    s = v.toFixed(4)
    cut = s.indexOf('.') + 3
  } else if (v >= 0.01) {
    s = v.toFixed(6)
    cut = 5
  } else {
    s = v.toFixed(9)
    cut = 7
  }
  return [s.slice(0, cut), s.slice(cut)]
}

/** Ноль — приглушённая точка, иначе «0.00» неотличим от «нет данных». */
export const ZERO_DOT = '·'

export function unitsToNumber(units: bigint, decimals: number): number {
  return Number(units) / 10 ** decimals
}

/**
 * Часы:минуты:секунды в часовом поясе устройства читателя, не сервера. Все
 * бэкенд-скрипты (collector.py, aggregator.py) шлют epoch ms в UTC — здесь
 * единственное место, где это превращается в отображаемую строку.
 */
export function localTime(ms: number): string {
  return new Date(ms).toLocaleTimeString([], { hour12: false })
}
